import styles from './invalidlink.module.css';
import { DescriptionBlock } from "../../../../shared/ui/DescriptionBlock/DescriptionBlock";
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { resetQuery } from '../../../../entities/passwordReset/models/events';
import { Button } from '../../../../shared/ui/Button/Button';

interface IInvalidLinkProps {
    text: string
}

export function InvalidLink({ text }: IInvalidLinkProps) {
    const navigate = useNavigate();

    useEffect(() => {
        return () => resetQuery();
    }, []);

    return (
        <div className={styles.invalidLinkBlock}>
            <DescriptionBlock>{text}</DescriptionBlock>

            <div className={styles.buttonsBlock}>
                <Button
                    type="button"
                    onClick={() => navigate('/reset-password')}
                    className={`${styles.confirmButton} ${styles.button}`}
                >
                    Восстановить
                </Button>
                <Button
                    variant='text'
                    color='var(--red)'
                    hoverColor='var(--red_hover)'
                    type="button"
                    onClick={() => navigate('/login')}
                >
                    Отменить
                </Button>
            </div>
            
        </div>
    )
}